/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterState
 */
export interface GlobalFilterState {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterState
     */
    disabled?: boolean;
}

export function GlobalFilterStateFromJSON(json: any): GlobalFilterState {
    return GlobalFilterStateFromJSONTyped(json, false);
}

export function GlobalFilterStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function GlobalFilterStateToJSON(value?: GlobalFilterState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


